import { useLoaderData } from "react-router";
import { WidgetData } from "../../types/WidgetData";
import WidgetWrapper from "../../WidgetWrapper";
import { HistoryComponent } from "./HistoryPage";
import { useState } from "react";
import {
  DefaultHistoryStore,
  HistoryStore,
  HistoryStoreContext,
} from "../../stores/history";
import {
  DefaultWidgetStore,
  WidgetStore,
  WidgetStoreContext,
} from "../../stores/WidgetStore";
import { Widget } from "../../types/Widget";
import { HistoryWidgetSettings, HistoryWidgetSettingsContenxt } from "./HistoryWidgetSettings";
import { useAuth } from "../../contexts/AuthContext";

export default function HistoryWidgetPage() {
  const { recipientId, conf, widgetId, settings } =
    useLoaderData() as WidgetData;
  const { accessToken } = useAuth();

  const widgetSettings = Widget.configFromJson(
    settings,
  ) as HistoryWidgetSettings;

  const [store] = useState<HistoryStore>(
    () => new DefaultHistoryStore(accessToken ?? "", recipientId, widgetId, conf),
  );
  const [widgetStore] = useState<WidgetStore>(() => new DefaultWidgetStore());

  return (
    <WidgetWrapper>
      <style
        dangerouslySetInnerHTML={{
          __html: `#root {overflow: auto; background-color: var(--oda-color-100);}`,
        }}
      />
      <style
        dangerouslySetInnerHTML={{
          __html: `@media(min-width: 450px){#root {padding: 12px 15px;}`,
        }}
      />
      <style
        dangerouslySetInnerHTML={{
          __html: `@media(max-width: 450px){#root {padding: 6px 3px;}`,
        }}
      />
      <WidgetStoreContext.Provider value={widgetStore}>
        <HistoryStoreContext.Provider value={store}>
          <HistoryWidgetSettingsContenxt.Provider value={widgetSettings}>
            <HistoryComponent showHeader={false} />
          </HistoryWidgetSettingsContenxt.Provider>
        </HistoryStoreContext.Provider>
      </WidgetStoreContext.Provider>
    </WidgetWrapper>
  );
}
